import { isObject } from "@spoferan/spoferan-ts-core";
import { useOnline } from "@vueuse/core";
import { useI18n } from "#imports";
export function useErrorParser() {
  const isOnline = useOnline();
  const { t } = useI18n();
  function parseErrorMessage(error) {
    const fallbackMessage = !isOnline.value ? t("error.offline.message") : t("error.unknown");
    if (!error) {
      return fallbackMessage;
    }
    if (!isObject(error)) {
      return error;
    }
    if (error.message) {
      return error.message;
    }
    const code = parseInt(error.statusCode);
    switch (code) {
      case 403:
        return t("error.403.message");
      case 404:
        return t("error.404.message");
      case 422:
        return t("error.422.message");
      case 503:
        return t("error.503.message");
    }
  }
  return {
    parseErrorMessage
  };
}
